import { useOutletContext } from "react-router-dom";
import type { DriverProfile, DriverSummary } from "./driverApi";

export interface DriverContext {
  /** null until loaded from the API. */
  driver: DriverProfile | null;
  reload: () => Promise<void>;
  /** Dashboard numbers and sidebar badges (GET /driver/summary); null until loaded. */
  summary: DriverSummary | null;
  refreshSummary: () => void;
  /** Replaces the driver after a profile save. */
  setDriver: (driver: DriverProfile) => void;
}

/** The driver loaded by DriverLayout, for the pages inside it. */
export const useDriver = () => useOutletContext<DriverContext>();
